var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group mb-0"},[(_vm.puedeEditar)?_c('b-form-select',{staticClass:"select-tipo",attrs:{"multiple":"","select-size":4,"options":_vm.options},model:{value:(_vm.tipos),callback:function ($$v) {_vm.tipos=$$v},expression:"tipos"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }